import { makeStyles, Theme, createStyles } from '@material-ui/core';

import commonStyles from 'config/commonStyles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        slectorFormRoot: {
            '& .MuiTypography-body1': {
                fontSize: 14,
            },
        },
        wizzardStepTitle: {
            color: theme.palette.primary.main,
            letterSpacing: 1.25,
            fontWeight: 500,
            textTransform: 'uppercase',
            size: 14,
            marginLeft: 15,
        },
        wizzardStepTitleDisabled: {
            color: theme.palette.text.secondary,
        },
        featuresSelectorContainer: {
            paddingLeft: 40,
            paddingTop: 20,
        },
        featuresSelectorSubtitle: {
            fontSize: 12,
            color: theme.palette.text.secondary,
            marginTop: 10,
            marginBottom: 25,
        },
        featuresSelectorSectionTitle: {
            fontSize: 18,
            fontWeight: 500,
            color: theme.palette.common.black,
            marginBottom: 15,
            '&.MuiFormLabel-root.Mui-focused': {
                color: 'inherit !important',
            },
        },
        formControl: {
            marginRight: 40,
        },
    })
);
